import React, { useState, useEffect, useRef, useMemo } from "react";
import "./CategoriaApostaPage.css";
import { useParams, useNavigate } from "react-router-dom";
import { auth, db } from "../firebase";
import { onAuthStateChanged } from "firebase/auth";
import { doc, setDoc, getDoc, getDocs, collection, serverTimestamp } from "firebase/firestore";
import initializeUserData from "../services/initializeUserData";
import { getTotalPosicoes, categoriasPorModo } from "../services/estruturaCategorias";
// [DESACTIVADO] import criarSemanasSeNecessario from '../services/criarSemanasSeNecessario';
import atualizarPopularidade from "../services/atualizarPopularidade";
import { gerarChaveCandidato } from "../services/atualizarPopularidade";
import { calcularPopularidadePonderada } from "../services/calcularPopularidadePonderada";
import obterNomeCategoria from "../utils/obterNomeCategoria";
import snapDropdown from "../services/snapDropdown"; // ajusta o caminho se necessário
import AlertaUrgente from "../components/AlertaUrgente";
import { createPortal } from "react-dom";

const animacoesJaFeitas = new Set();

// CONFIGURAÇÕES POR CATEGORIA
const estruturaPorCategoria = {
  "melhorfilmeinternacional": "titulo+pais",
  "melhorfilmeemlinguanaoinglesa": "titulo+pais",
  "melhorcancaooriginal": "titulo+filme",
  "melhorcancao": "titulo+filme",
  "melhordirecao": "titulo+filme",
  "melhorator": "titulo+filme",
  "melhoratriz": "titulo+filme",
  "melhoratorcoadjuvante": "titulo+filme",
  "melhoratrizcoadjuvante": "titulo+filme",
  "melhoratoremdrama": "titulo+filme",
  "melhoratrizemdrama": "titulo+filme",
  "melhoratoremcomediaoumusical": "titulo+filme",
  "melhoratrizemcomediaoumusical": "titulo+filme",
  "melhoratoratrizemascensao": "titulo+filme",
  "melhorjovematoratriz": "titulo+filme"
};

const getIconeStatus = (categoria) => {
  switch (categoria?.status) {
    case "azul":
      return "https://i.imgur.com/n1m7Q2a.png";
    case "verde":
      return "https://i.imgur.com/UxGgT5T.png";
    default:
      return "https://i.imgur.com/eutdKER.png";
  }
};

function calcularStatusCategoriaAtual(apostas, dataAtualizacao, modo, categoriaId, uid) {
  const temApostas = apostas.some((a) => a && a.titulo);
  if (!temApostas) return "cinza";

  const chaveLocal = `categoriasAtualizadas-${uid}-${modo}`;
  const dados = localStorage.getItem(chaveLocal);

  if (!dados) return "verde";

  try {
    const { categorias } = JSON.parse(dados);

    if (!categorias.hasOwnProperty(categoriaId)) return "verde";

    const validadeStr = categorias[categoriaId];
    const dataExpiracao = new Date(validadeStr);
    const agora = new Date();

    if (agora <= dataExpiracao) {
      return "azul";
    } else {
      return "verde";
    }
  } catch (erro) {
    console.error("Erro ao verificar status azul:", erro);
    return "verde";
  }
}

function extrairDadosCandidato(docCandidato, categoria) {
  const tituloPadrao = docCandidato.querySelector(".wsite-com-category-product-name")?.textContent.trim();
  const extra = docCandidato.querySelector(".descricao-curta-dinamica")?.textContent.trim();
  let imagem = docCandidato.querySelector("img")?.getAttribute("src") || "https://i.imgur.com/6MbQoCt.png";
  if (imagem.startsWith("/uploads")) {
    imagem = "https://www.termometrooscar.com" + imagem;
  }

  if (["melhorfilmeinternacional", "melhorfilmeemlinguanaoinglesa"].includes(categoria)) {
    return { titulo: tituloPadrao, pais: extra, imagem };
  }

  if (["melhorcancaooriginal", "melhorcancao"].includes(categoria)) {
    if (tituloPadrao?.includes(" - ")) {
      const [titulo, filme] = tituloPadrao.split(" - ");
      return { titulo: titulo.trim(), filme: filme.trim(), imagem };
    }
    return { titulo: tituloPadrao, imagem };
  }

  const categoriasComFilme = Object.keys(estruturaPorCategoria).filter(key => estruturaPorCategoria[key].includes("filme"));
  if (categoriasComFilme.includes(categoria)) {
    return { titulo: tituloPadrao, filme: extra, imagem };
  }

  return { titulo: tituloPadrao, imagem };
}

const quantidadePorCategoria = {
  'oscar-indicados': {
    melhorfilme: 10, melhordirecao: 5, melhorator: 5, melhoratriz: 5, melhoratorcoadjuvante: 5,
    melhoratrizcoadjuvante: 5, melhorescalacaodeelenco: 5, melhorroteirooriginal: 5, melhorroteiroadaptado: 5,
    melhorfilmeinternacional: 5, melhoranimacao: 5, melhordocumentario: 5, melhoredicao: 5,
    melhorfotografia: 5, melhorfigurino: 5, melhordirecaodearte: 5, melhormaquiagem: 5,
    melhorefeitosvisuais: 5, melhortrilhasonora: 5, melhorcancaooriginal: 5, melhorsom: 5,
    melhorcurtametragem: 5, melhoranimacaoemcurtametragem: 5, melhordocumentarioemcurtametragem: 5, melhorduble: 5
  },
  'oscar-vencedores': {
    melhorfilme: 10, melhordirecao: 5, melhorator: 5, melhoratriz: 5, melhoratorcoadjuvante: 5,
    melhoratrizcoadjuvante: 5, melhorescalacaodeelenco: 5, melhorroteirooriginal: 5, melhorroteiroadaptado: 5,
    melhorfilmeinternacional: 5, melhoranimacao: 5, melhordocumentario: 5, melhoredicao: 5,
    melhorfotografia: 5, melhorfigurino: 5, melhordirecaodearte: 5, melhormaquiagem: 5,
    melhorefeitosvisuais: 5, melhortrilhasonora: 5, melhorcancaooriginal: 5, melhorsom: 5,
    melhorcurtametragem: 5, melhoranimacaoemcurtametragem: 5, melhordocumentarioemcurtametragem: 5, melhorduble: 5
  },
  'globodeouro-indicados': {
    melhorfilmeemdrama: 6, melhorfilmeemcomedia: 6, melhorfilmeblockbuster: 8, melhordirecao: 6,
    melhoratoremdrama: 6, melhoratrizemdrama: 6, melhoratoremcomediaoumusical: 6, melhoratrizemcomediaoumusical: 6,
    melhoratorcoadjuvante: 6, melhoratrizcoadjuvante: 6, melhorroteiro: 6, melhorcancaooriginal: 6,
    melhortrilhasonora: 6, melhoranimacao: 6, melhorfilmeemlinguanaoinglesa: 6
  },
  'globodeouro-vencedores': {
    melhorfilmeemdrama: 6, melhorfilmeemcomedia: 6, melhorfilmeblockbuster: 8, melhordirecao: 6,
    melhoratoremdrama: 6, melhoratrizemdrama: 6, melhoratoremcomediaoumusical: 6, melhoratrizemcomediaoumusical: 6,
    melhoratorcoadjuvante: 6, melhoratrizcoadjuvante: 6, melhorroteiro: 6, melhorcancaooriginal: 6,
    melhortrilhasonora: 6, melhoranimacao: 6, melhorfilmeemlinguanaoinglesa: 6
  },
  'sagawards-indicados': {
    melhorelenco: 5, melhorator: 5, melhoratriz: 5, melhoratorcoadjuvante: 5,
    melhoratrizcoadjuvante: 5, melhorequipededuble: 5
  },
  'sagawards-vencedores': {
    melhorelenco: 5, melhorator: 5, melhoratriz: 5, melhoratorcoadjuvante: 5,
    melhoratrizcoadjuvante: 5, melhorequipededuble: 5
  },
  'criticschoice-indicados': {
    melhorfilme: 10, melhordirecao: 10, melhorator: 6, melhoratriz: 6, melhoratorcoadjuvante: 6,
    melhoratrizcoadjuvante: 6, melhorjovematoratriz: 6, melhorroteirooriginal: 6,
    melhorroteiroadaptado: 6, melhorfotografia: 6, melhoredicao: 6, melhordirecaodearte: 6,
    melhorfigurino: 6, melhormaquiagem: 6, melhorefeitosvisuais: 6, melhorcomedia: 6,
    melhorfilmeinternacional: 6, melhoranimacao: 6, melhorcancao: 6, melhortrilhasonora: 6, melhorduble: 6, melhorescalacaodeelenco: 6, melhorsom: 6
  },
  'criticschoice-vencedores': {
    melhorfilme: 10, melhordirecao: 6, melhorator: 6, melhoratriz: 6, melhoratorcoadjuvante: 6,
    melhoratrizcoadjuvante: 6, melhorjovematoratriz: 6, melhorroteirooriginal: 6,
    melhorroteiroadaptado: 6, melhorfotografia: 6, melhoredicao: 6, melhordirecaodearte: 6,
    melhorfigurino: 6, melhormaquiagem: 6, melhorefeitosvisuais: 6, melhorcomedia: 6,
    melhorfilmeinternacional: 6, melhoranimacao: 6, melhorcancao: 6, melhortrilhasonora: 6, melhorduble: 6, melhorescalacaodeelenco: 6, melhorsom: 6
  },
  'dga-indicados': { melhordirecao: 5 },
  'dga-vencedores': { melhordirecao: 5 },
  'pga-indicados': { melhorfilme: 10, melhoranimacao: 5, melhordocumentario: 7 },
  'pga-vencedores': { melhorfilme: 10, melhoranimacao: 5, melhordocumentario: 7 },
  'bafta-indicados': {
    melhorfilme: 5, melhordirecao: 6, melhorfilmeinternacional: 5, melhorfilmebritanico: 10,
    melhorfilmefamiliar: 4, melhordocumentario: 5, melhoranimacao: 4, melhorator: 6, melhoratriz: 6,
    melhoratorcoadjuvante: 6, melhoratrizcoadjuvante: 6, melhoratoratrizemascensao: 5, melhorescalacao: 5,
    melhorestreiadeumdiretorescritorouprodutorbritanico: 5, melhorroteirooriginal: 5, melhorroteiroadaptado: 5,
    melhorfotografia: 5, melhorfigurino: 5, melhorsom: 5, melhoredicao: 5, melhorefeitosvisuais: 5,
    melhordirecaodearte: 5, melhormaquiagem: 5, melhortrilhasonora: 5, melhorcurtabritanico: 5,
    melhorcurtadeanimacaobritanico: 3
  },
  'bafta-vencedores': {
    melhorfilme: 5, melhordirecao: 6, melhorfilmeinternacional: 5, melhorfilmebritanico: 10,
    melhorfilmefamiliar: 4, melhordocumentario: 5, melhoranimacao: 3, melhorator: 6, melhoratriz: 6,
    melhoratorcoadjuvante: 6, melhoratrizcoadjuvante: 6, melhoratoratrizemascensao: 5, melhorescalacao: 5,
    melhorestreiadeumdiretorescritorouprodutorbritanico: 5, melhorroteirooriginal: 5, melhorroteiroadaptado: 5,
    melhorfotografia: 5, melhorfigurino: 5, melhorsom: 5, melhoredicao: 5, melhorefeitosvisuais: 5,
    melhordirecaodearte: 5, melhormaquiagem: 5, melhortrilhasonora: 5, melhorcurtabritanico: 5,
    melhorcurtadeanimacaobritanico: 3
  }
};

function CategoriaApostaPage() {
  const [usuarioPronto, setUsuarioPronto] = useState(false);
  const [usuario, setUsuario] = useState(null);
  const [uid, setUid] = useState(null); // ✅ novo: para namespacing das chaves
  const [usuarioFirestore, setUsuarioFirestore] = useState(null);
  const { modo, categoria: categoriaId } = useParams();
  const [premiacao, tipoAposta] = modo.split("-");
  const chaveModo = `${premiacao}-${tipoAposta}`;
  const [popupErro, setPopupErro] = useState({ aberto: false, mensagem: "" });
  const quantidadeMaxima = quantidadePorCategoria[chaveModo]?.[categoriaId] || 10;
  const [popupLoading, setPopupLoading] = useState(false);
  const [popularidadeMap, setPopularidadeMap] = useState({});
  const [popularidadePonderada, setPopularidadePonderada] = useState({});
  const [popularidadePronta, setPopularidadePronta] = useState(false);
  const [dataSemanaAberta, setDataSemanaAberta] = useState(null);
  const [dataSemanaFechada, setDataSemanaFechada] = useState(null);
  const listaCategoriasDoModo = categoriasPorModo[modo] || [];
  const [proximaCategoriaAposConfirmar, setProximaCategoriaAposConfirmar] = useState(false);
  const [statusCategoriaAtual, setStatusCategoriaAtual] = useState("cinza");
  const [iconeStatus, setIconeStatus] = useState(getIconeStatus({ status: "cinza" })); // ⬅️ AQUI
  const [temApostasAtivas, setTemApostasAtivas] = useState(false);
  const [disponivel, setDisponivel] = useState(null);
  const [proximaDisponivel, setProximaDisponivel] = useState(null);
  const [categoriasDisponiveis, setCategoriasDisponiveis] = useState([]);
  const [carregandoCandidatos, setCarregandoCandidatos] = useState(true);
  const [ultimaAtualizacaoStorage, setUltimaAtualizacaoStorage] = useState(null);
  const [mensagemFechado, setMensagemFechado] = useState(''); 
  const imagemPerfilDefault = "https://firebasestorage.googleapis.com/v0/b/previsoesoscar.firebasestorage.app/o/fotosUsuarios%2Fdefaults%2Fperfil.png?alt=media&token=e1de994b-b337-41ea-992f-fb0929611d36";
  const imagemCabecalhoDefault = "https://firebasestorage.googleapis.com/v0/b/previsoesoscar.firebasestorage.app/o/fotosUsuarios%2Fdefaults%2Fcapa.png?alt=media&token=5a95f438-714b-4eea-a506-bdb619c43c5a"; 
  const textoTipoAposta = tipoAposta === "vencedores" ? "APOSTAS DOS VENCEDORES" : "APOSTAS DOS INDICADOS";
  const nomePremiacao = premiacao.replace(/oscar/, "OSCAR")
    .replace(/bafta/, "BAFTA")
    .replace(/sagawards/, "THE ACTOR AWARDS")
    .replace(/dga/, "DGA AWARDS")
    .replace(/pga/, "PGA AWARDS")
    .replace(/globodeouro/, "GLOBO DE OURO")
    .replace(/criticschoice/, "CRITICS CHOICE")
    .toUpperCase();

  const [dropdownAberto, setDropdownAberto] = useState(false);
  const [candidatos, setCandidatos] = useState([]);
  const [busca, setBusca] = useState('');
  const [apostas, setApostas] = useState([]);
  const [showSticky, setShowSticky] = useState(false);
  const tituloRef = useRef(null);

  const candidatosHeaderRef = useRef(null);
  const apostasColRef = useRef(null);
  const [showMiniBar, setShowMiniBar] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const selecionadosPorId = useMemo(() => {
    return new Set((apostas || []).filter(Boolean).map(a => a.idInterno));
  }, [apostas]);

  const apostaPorId = useMemo(() => {
    const m = new Map();
    (apostas || []).filter(Boolean).forEach(a => {
      if (a.idInterno) m.set(a.idInterno, a);
    });
    return m;
  }, [apostas]);

  const candidatosPorId = useMemo(() => {
    const m = new Map();
    (candidatos || []).forEach((c) => {
      if (c?.idInterno) m.set(c.idInterno, c);
    });
    return m;
  }, [candidatos]);

  const temAlgoParaAtualizar = useMemo(() => {
    if (!apostas?.length || !candidatos?.length) return false;

    return apostas.some((ap) => {
      if (!ap || !ap.idInterno) return false;

      const atual = candidatosPorId.get(ap.idInterno) || candidatos.find(c => c.idInterno === ap.idInterno);
      if (!atual) return false;

      const mudouTitulo = (ap.titulo ?? "").trim() !== (atual.titulo ?? "").trim();
      const mudouFilme  = (ap.filme  ?? "").trim() !== (atual.filme  ?? "").trim();
      const mudouPais   = (ap.pais   ?? "").trim() !== (atual.pais   ?? "").trim();
      const mudouImg    = (ap.imagem ?? "")        !== (atual.imagem ?? "");

      return mudouTitulo || mudouFilme || mudouPais || mudouImg;
    });
  }, [apostas, candidatos, candidatosPorId]);

  const atualizarTodos = () => {
    setApostas((lista) => {
      if (!Array.isArray(lista)) return lista;

      const nova = lista.map((ap) => {
        if (!ap || !ap.idInterno) return ap;

        const atual = candidatosPorId.get(ap.idInterno) || candidatos.find(c => c.idInterno === ap.idInterno);
        if (!atual) return ap;

        const mudouTitulo = (ap.titulo ?? "").trim() !== (atual.titulo ?? "").trim();
        const mudouFilme  = (ap.filme  ?? "").trim() !== (atual.filme  ?? "").trim();
        const mudouPais   = (ap.pais   ?? "").trim() !== (atual.pais   ?? "").trim();
        const mudouImg    = (ap.imagem ?? "")        !== (atual.imagem ?? "");

        if (!(mudouTitulo || mudouFilme || mudouPais || mudouImg)) return ap;

        return {
          ...ap,
          titulo:   atual.titulo,
          filme:    atual.filme  ?? "",
          pais:     atual.pais   ?? "",
          imagem:   atual.imagem ?? ap.imagem,
          idInterno: ap.idInterno,
        };
      });

      return nova;
    });
  };

  const categorias = (categoriasPorModo[modo] || []).map(slug => ({
    slug,
    nome: obterNomeCategoria(slug)
  }));

  useEffect(() => {
    if (disponivel === false) {
      document.body.style.overflow = "hidden"; // Impede rolagem
    } else {
      document.body.style.overflow = ""; // Restaura rolagem normal
    }

    return () => {
      document.body.style.overflow = ""; // Garante que volta ao normal ao desmontar
    };
  }, [disponivel]);

  useEffect(() => {
    console.log("🔁 Categoria mudou para:", categoriaId);
    window.scrollTo(0, 0); // caso queiras garantir rolagem ao topo
  }, [categoriaId]);

  useEffect(() => {
    // ⚠️ Protege contra estado inicial vazio
    if (!categoriasDisponiveis.length) return;

    const cat = categoriasDisponiveis.find(c => c.id === categoriaId);

    if (!cat) {
      setDisponivel(false);
      setMensagemFechado('Categoria não encontrada.');
      return;
    }

    if (cat.disponivel === false) {
      setDisponivel(false);
      setMensagemFechado(cat.mensagem || 'A categoria não está disponível para apostas!');

      const ordemOficial = categoriasPorModo[modo] || [];
      const idxAtual = ordemOficial.indexOf(categoriaId);

      let proxima = null;
      for (let i = idxAtual + 1; i < ordemOficial.length; i++) {
        const catId = ordemOficial[i];
        const encontrada = categoriasDisponiveis.find(
          (c) => c.id === catId && c.disponivel
        );
        if (encontrada) {
          proxima = encontrada.id;
          break;
        }
      }

      setProximaDisponivel(proxima);
    } else {
      setDisponivel(true);
      setProximaDisponivel(null);
    }
  }, [categoriaId, categoriasDisponiveis, modo]);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user) {
        setUsuario(user);
        setUid(user.uid); // ✅
        // Verifica se já temos dados no sessionStorage
        const dadosSalvos = sessionStorage.getItem("usuarioFirestore");

        if (dadosSalvos) {
          setUsuarioFirestore(JSON.parse(dadosSalvos));
        } else {
          const docRef = doc(db, "usuarios", user.uid);
          const docSnap = await getDoc(docRef);
          if (docSnap.exists()) {
            const dados = docSnap.data();
            setUsuarioFirestore(dados);
            sessionStorage.setItem("usuarioFirestore", JSON.stringify(dados));
          } else {
            console.warn("Documento do usuário não encontrado no Firestore.");
          }
        }
      } else {
        navigate("/login");
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    async function carregarCategoriasDisponiveis() {
      const cacheKey = `categoriasDisponiveis-${modo}`;
      const cache = sessionStorage.getItem(cacheKey);

      if (cache) {
        try {
          const categorias = JSON.parse(cache);
          setCategoriasDisponiveis(categorias);
          return;
        } catch (erro) {
          console.warn("❌ Erro ao interpretar cache de categorias:", erro);
        }
      }

      try {
        const categoriasRef = collection(db, `modos/${modo}/categorias`);
        const snapshot = await getDocs(categoriasRef);

        const lista = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));

        setCategoriasDisponiveis(lista);
        sessionStorage.setItem(cacheKey, JSON.stringify(lista));
      } catch (erro) {
        console.error("Erro ao carregar categorias disponíveis:", erro);
      }
    }

    carregarCategoriasDisponiveis();
  }, [modo]);

  useEffect(() => {
    const tem = apostas.some((a) => a && a.titulo);
    setTemApostasAtivas(tem);
  }, [apostas]);

  useEffect(() => {
    setApostas(Array(quantidadeMaxima).fill(null));
  }, [quantidadeMaxima]);

  const navigate = useNavigate();

  const candidatosFiltrados = candidatos.filter(cand =>
    cand.titulo?.toLowerCase().includes(busca.toLowerCase()) ||
    cand.filme?.toLowerCase().includes(busca.toLowerCase()) ||
    cand.pais?.toLowerCase().includes(busca.toLowerCase())
  );

  const categoriaAtual = categorias.find(cat => cat.slug === categoriaId);

  const toggleDropdown = () => setDropdownAberto(prev => !prev);

  const selecionarCategoria = (cat) => {
    setDropdownAberto(false);
    navigate(`/perfil/${modo}/${cat.slug}`);
  };

  const adicionarIcon = "https://i.imgur.com/DD7Wx9l.png";
  const removerIcon = "https://i.imgur.com/6iffBZx.png";
  const setaCima = "https://i.imgur.com/pGOkKBq.png";
  const setaBaixo = "https://i.imgur.com/i55QPCu.png";
  const posterDefault = "https://i.imgur.com/6MbQoCt.png";
  const posterCandidato = "https://i.imgur.com/nH46JCd.png";
  const iconePopularidade = "https://i.imgur.com/b2YD4sL.png";
  const iconePesquisa = "https://i.imgur.com/e5yCw0Q.png";

  const normalizar = (s) => (s ?? "").trim();
  const pegarSubtitulo = (obj) => {
  const filme = (obj?.filme ?? "").trim();
  const pais  = (obj?.pais  ?? "").trim();
  return filme || pais || "";
};

  function gerarIdInternoFallback(cand) {
    const base = (cand.titulo || "").replace(/\s+/g, "-").toLowerCase();
    return base + "-" + Math.floor(Math.random() * 10000);
  }

  const adicionarCandidato = (cand) => {
    if (!cand.idInterno) {
      console.warn("Candidato sem idInterno — ignorado:", cand);
      return;
    }
    if (selecionadosPorId.has(cand.idInterno)) return;

    const novaApostas = [...apostas];
    const primeiraVazia = novaApostas.findIndex((a) => a === null);
    if (primeiraVazia === -1) return;

    const candidatoComId = {
      ...cand,
      idInterno: cand.idInterno,
    };

    novaApostas[primeiraVazia] = candidatoComId;
    setApostas(novaApostas);
  };

  const obterPopularidade = (cand) => {
    const chave = gerarChaveCandidato(cand);
    const total = popularidadeMap.totalUsuarios || 0;
    const candidato = popularidadeMap.candidatos?.[chave];

    console.log("🔍 Verificando popularidade:", {
      chave,
      total,
      candidato
    });

    if (!candidato || total === 0) return "0.0";

    const vezes = candidato.vezesEscolhido || 0;
    return ((vezes / total) * 100).toFixed(1);
  };

  const obterPopularidadePonderada = (cand) => {
    const chave = gerarChaveCandidato(cand);
    return popularidadePonderada[chave] || 0;
  };

  const removerCandidato = (index) => {
    const novaApostas = [...apostas];
    novaApostas.splice(index, 1);
    novaApostas.push(null);
    setApostas(novaApostas);
  };

  const moverCandidato = (index, direcao) => {
    const novaApostas = [...apostas];
    const novoIndex = index + direcao;
    if (novoIndex < 0 || novoIndex >= novaApostas.length) return;

    const atual = novaApostas[index];
    const destino = novaApostas[novoIndex];

    novaApostas[index] = { ...destino };
    novaApostas[novoIndex] = { ...atual };

    setApostas(novaApostas);
  };

  useEffect(() => {
    let jaExecutou = false;
    let cancelado = false;

    async function carregarCandidatos() {
      if (jaExecutou || cancelado) return;
      jaExecutou = true;

      setCarregandoCandidatos(true);
      setCandidatos([]);

      try {
        const ref = doc(db, `modos/${modo}/categorias/${categoriaId}`);
        const snap = await getDoc(ref);
        if (!snap.exists()) return;

        const dados = snap.data();
        const { linkCategoria } = dados;
        if (!linkCategoria) {
          setCandidatos([]);
          return;
        }

        const inicio = dados.inicio;
        const fim = dados.fim;

        const dataAbertura = inicio ? new Date(`${inicio}T00:00:00Z`) : null;
        const dataFechamento = fim ? new Date(`${fim}T23:59:59Z`) : null;

        setDataSemanaAberta(dataAbertura);
        setDataSemanaFechada(dataFechamento);

        console.log("📅 Datas carregadas:", {
          inicio,
          fim,
          dataAbertura,
          dataFechamento
        });

        const urlCategoria = "https://autumn-tree-2457.renanmorg.workers.dev/?url=" + encodeURIComponent(linkCategoria);
        const resposta = await fetch(urlCategoria);
        const htmlCategoria = await resposta.text();
        const parser = new DOMParser();
        const htmlDoc = parser.parseFromString(htmlCategoria, "text/html");

        const blocos = htmlDoc.querySelectorAll(".wsite-com-category-product-wrap");
        const resultados = [];

        for (const bloco of blocos) {
          const dados = extrairDadosCandidato(bloco, categoriaId);

          const cardEl = bloco.closest(".wsite-com-category-product");
          const idInterno = cardEl?.getAttribute("data-id") || "";

          if (dados && idInterno) {
            dados.idInterno = idInterno;
          }

          if (dados) resultados.push(dados);
        }

        if (!cancelado) {
  const completos = await completarDescricaoCurta(resultados, blocos);
  if (cancelado) return;

  setCandidatos(completos);
  setCarregandoCandidatos(false);
}
      } catch (erro) {
        console.error("Erro ao carregar candidatos:", erro);
      }
    }

   async function completarDescricaoCurta(candidatosParciais, blocos) {
  const atualizados = [...candidatosParciais];

  const promessas = candidatosParciais.map(async (cand, i) => {
    const linkEl = blocos[i]?.querySelector("a.wsite-com-link");
    const linkRelativo = linkEl?.getAttribute("href");
    if (!linkRelativo || !linkRelativo.startsWith("/store/")) return;

    const urlCompleto =
      "https://autumn-tree-2457.renanmorg.workers.dev/?url=" +
      encodeURIComponent(`https://www.termometrooscar.com${linkRelativo}`);

    try {
      const resIndividual = await fetch(urlCompleto);
      if (!resIndividual.ok) return;

      const htmlIndividual = await resIndividual.text();
      const docIndividual = new DOMParser().parseFromString(htmlIndividual, "text/html");
      const short = docIndividual
        .querySelector("#wsite-com-product-short-description p")
        ?.textContent.trim();

      if (!short) return;

      if (["melhorfilmeinternacional", "melhorfilmeemlinguanaoinglesa"].includes(categoriaId)) {
        // aqui continua a usar o short como país
        atualizados[i].pais = short;
      }
      // não sobrescrever filme em melhor canção
      else if (
        estruturaPorCategoria[categoriaId]?.includes("filme") &&
        !["melhorcancao", "melhorcancaooriginal"].includes(categoriaId)
      ) {
        atualizados[i].filme = short;
      }
    } catch (erro) {
      console.error("Erro ao buscar descrição curta individual:", erro);
    }
  });

  await Promise.all(promessas);
  return atualizados; // ✅ agora retorna
}

carregarCandidatos();
return () => { cancelado = true; };
}, [modo, categoriaId]);

  useEffect(() => {
    if (!usuarioPronto || !dataSemanaAberta || !dataSemanaFechada) return;

    const hoje = new Date();

    const temApostas = apostas.some((a) => a && a.titulo);
    const dentroDaSemana =
      hoje >= dataSemanaAberta && hoje <= dataSemanaFechada;

    let status = "cinza";
    if (temApostas) {
      status = dentroDaSemana ? "azul" : "verde";
    }

    const chave = `statusCategoria-${uid}-${modo}-${categoriaId}`;
    sessionStorage.setItem(chave, status);

    if (status === "verde") {
      console.log("💾 Gravando no localStorage:", chave);
      localStorage.setItem(chave, "verde");
    }

    if (!usuarioPronto) {
      console.log("⏳ Aguardando usuário...");
      return;
    }

    console.log("📦 Status calculado e salvo:", {
      chave,
      status,
      hoje,
      dataSemanaAberta,
      dataSemanaFechada,
      apostas,
    });
  }, [usuarioPronto, dataSemanaAberta, dataSemanaFechada, apostas, uid, modo, categoriaId]);

  useEffect(() => {
    if (!usuarioPronto) return;

    const total = getTotalPosicoes(modo, categoriaId);
    const user = auth.currentUser;
    if (!user) {
      setApostas(Array(total).fill(null));
      return;
    }

    const carregar = async () => {
      try {
        const ref = doc(db, `usuarios/${user.uid}/apostasAtivas/${modo}/categorias/${categoriaId}`);
        const snap = await getDoc(ref);

        if (snap.exists()) {
          const data = snap.data();

          const apostasSalvas = Object.entries(data)
            .filter(([key]) => !isNaN(key))
            .sort((a, b) => parseInt(a[0]) - parseInt(b[0]))
            .map(([_, value]) => ({
              titulo: value.titulo,
              imagem: value.imagem || "",
              filme: value.filme || "",
              pais: value.pais || "",
              idInterno: value.idInterno
            }));

          while (apostasSalvas.length < total) apostasSalvas.push(null);
          setApostas(apostasSalvas);
        } else {
          setApostas(Array(total).fill(null));
        }
      } catch (erro) {
        console.error("Erro ao carregar apostas:", erro);
        setApostas(Array(total).fill(null));
      }
    };

    carregar();
  }, [usuarioPronto, modo, categoriaId]);

  useEffect(() => {
    const userAtual = auth.currentUser;
    if (userAtual) {
      setUsuario(userAtual);
      setUid(userAtual.uid); // ✅
      setUsuarioPronto(true);
      return;
    }

    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user) {
        setUsuario(user);
        setUid(user.uid); // ✅
      }
      setUsuarioPronto(true);
    });

    return () => unsubscribe();
  }, []);

  function obterStatusCategoriaLocal(modo, categoriaId, temApostasAtivas, uid) {
    if (!temApostasAtivas) return "cinza";

    const chaveLocal = `categoriasAtualizadas-${uid}-${modo}`;
    const dados = localStorage.getItem(chaveLocal);

    if (!dados) return "verde";

    try {
      const { categorias } = JSON.parse(dados);

      const validadeStr = categorias[categoriaId.toLowerCase()];
      if (!validadeStr) return "verde";

      const validade = new Date(validadeStr);
      const agora = new Date();

      if (agora <= validade) {
        return "azul";
      } else {
        return "verde";
      }
    } catch (erro) {
      console.error("Erro ao verificar status local:", erro);
      return "verde";
    }
  }

  useEffect(() => {
    console.log("🛠 useEffect iniciou", {
      usuarioPronto,
      dataSemanaAberta,
      dataSemanaFechada,
      apostas
    });

    if (!usuarioPronto || apostas.length === 0) return;

    const user = auth.currentUser;
    if (!user) return;

    const docRef = doc(db, `usuarios/${user.uid}/apostasAtivas/${modo}/categorias/${categoriaId}`);

    getDoc(docRef).then((snap) => {
      const dataAtualizacao = snap.exists() ? snap.data().dataAtualizacao : null;

      const status = calcularStatusCategoriaAtual(
        apostas,
        dataAtualizacao,
        modo,
        categoriaId,
        user.uid // ✅
      );
      setStatusCategoriaAtual(status);
      const chave = `statusCategoria-${user.uid}-${modo}-${categoriaId.toLowerCase()}`;
      sessionStorage.setItem(chave, status);
      localStorage.setItem(chave, status);
    }).catch((erro) => {
      console.error("Erro ao obter status da categoria:", erro);
    });
  }, [usuarioPronto, dataSemanaAberta, dataSemanaFechada, apostas]);

useEffect(() => {
  let cancelado = false;

  setPopularidadePronta(false);
  setPopularidadePonderada({});
  setPopularidadeMap({});

  const carregarPopularidade = async () => {
    try {
      const ref = doc(db, `popularidade/${modo}/categorias/${categoriaId}`);
      const snap = await getDoc(ref);
      if (cancelado) return;

      if (snap.exists()) {
        const dados = snap.data();

        // guarda bruto (se você usa noutros lugares)
        setPopularidadeMap(dados.candidatos || {});

        // ====== NOVO: totalUsuarios dinâmico ======
        const totalUsuariosFS =
          (typeof dados.totalUsuarios === "number" && dados.totalUsuarios > 0)
            ? dados.totalUsuarios
            : (dados.usuarios ? Object.keys(dados.usuarios).length : 0);

        const totalPosicoes = getTotalPosicoes(modo, categoriaId);

        // pesos e curva (ajuste se quiser)
        const W_POS = 0.7;  // peso da posição
        const W_FREQ = 0.3; // peso da frequência absoluta
        const K_CURVA = 1.0; // 1 = linear; >1 empina topo

        const resultados = calcularPopularidadePonderada(
          dados.candidatos || {},
          totalPosicoes,
          totalUsuariosFS,
          W_POS,
          W_FREQ,
          K_CURVA
        );

        // garante zero para candidatos que ainda não têm entrada no doc
        const todos = candidatosFiltrados || [];
        for (const cand of todos) {
          const chave = gerarChaveCandidato(cand);
          if (resultados[chave] === undefined) resultados[chave] = 0;
        }

        setPopularidadePonderada(resultados);
      } else {
        console.log("📭 Documento de popularidade não existe.");
      }

      setPopularidadePronta(true);
    } catch (erro) {
      console.error("Erro ao buscar popularidade:", erro);
    }
  };

  carregarPopularidade();
  return () => { cancelado = true; };
}, [usuarioPronto, modo, categoriaId]);


  useEffect(() => {
    if (!popularidadePronta || candidatosFiltrados.length === 0) return;

    const novosResultados = {};
    let precisaAtualizar = false;

    for (const cand of candidatosFiltrados) {
      const chave = gerarChaveCandidato(cand);
      if (!(chave in popularidadePonderada)) {
        novosResultados[chave] = 0;
        precisaAtualizar = true;
      }
    }

    if (precisaAtualizar) {
      setPopularidadePonderada((prev) => ({
        ...prev,
        ...novosResultados
      }));
    }
  }, [popularidadePronta, candidatosFiltrados, popularidadePonderada]);

  function NumeroAnimado({ chave, valorFinal, duracao = 600 }) {
    const [valor, setValor] = useState(() =>
      animacoesJaFeitas.has(chave) ? valorFinal ?? 0 : 0
    );

    useEffect(() => {
      if (animacoesJaFeitas.has(chave)) return;

      animacoesJaFeitas.add(chave);

      let start = null;
      const animar = (timestamp) => {
        if (!start) start = timestamp;
        const progresso = timestamp - start;
        const progressoNormalizado = Math.min(progresso / duracao, 1);
        const valorInterpolado = (valorFinal ?? 0) * progressoNormalizado;
        setValor(Math.round(valorInterpolado));

        if (progresso < duracao) {
          requestAnimationFrame(animar);
        } else {
          setValor(Math.round(valorFinal ?? 0));
        }
      };

      requestAnimationFrame(animar);
    }, [chave, valorFinal, duracao]);

    return <>{valor}%</>;
  }

  useEffect(() => {
    setPopularidadePronta(false);
    setPopularidadePonderada({});
    setPopularidadeMap({});
  }, [modo, categoriaId]);

  useEffect(() => {
    if (!usuarioPronto) return;

    if (!temApostasAtivas) {
      setIconeStatus(getIconeStatus({ status: "cinza" }));
      return;
    }

    const timeout = setTimeout(() => {
      const statusSalvo = obterStatusCategoriaLocal(
        modo,
        categoriaId.toLowerCase(),
        temApostasAtivas,
        uid // ✅
      );
      const icone = getIconeStatus({ status: statusSalvo });
      setIconeStatus(icone);
    }, 300);

    return () => clearTimeout(timeout);
  }, [usuarioPronto, modo, categoriaId, temApostasAtivas, ultimaAtualizacaoStorage, uid]);

  useEffect(() => {
    let lastVisible = false;
    let ticking = false;

    const update = () => {
      ticking = false;
      if (!tituloRef.current) return;

      const top = tituloRef.current.getBoundingClientRect().top;

      if (!lastVisible && top < -80) {
        lastVisible = true;
        setShowSticky(true);
      } else if (lastVisible && top > -20) {
        lastVisible = false;
        setShowSticky(false);
      }
    };

    const onScroll = () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', update);

    update();

    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', update);
    };
  }, []);

  useEffect(() => {
    const mq = window.matchMedia('(max-width: 850px)');
    const update = () => setIsMobile(mq.matches);
    update();
    if (mq.addEventListener) mq.addEventListener('change', update);
    else mq.addListener(update);
    return () => {
      if (mq.removeEventListener) mq.removeEventListener('change', update);
      else mq.removeListener(update);
    };
  }, []);

  useEffect(() => {
    if (!isMobile) {
      setShowMiniBar(false);
      return;
    }

    const onScroll = () => {
      const candRect = candidatosHeaderRef.current?.getBoundingClientRect();
      const apostasRect = apostasColRef.current?.getBoundingClientRect();

      const passouDoTitulo = candRect ? candRect.bottom <= 0 : false;
      const aindaNaoChegouNasApostas = apostasRect
        ? apostasRect.top > window.innerHeight
        : true;

      setShowMiniBar(passouDoTitulo && aindaNaoChegouNasApostas);
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    return () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
    };
  }, [isMobile]);

  const limparApostas = () => {
    const novaLista = Array(quantidadeMaxima).fill(null);
    setApostas(novaLista);
  };

  const salvarApostas = async () => {
    const user = auth.currentUser;
    if (!user) {
      setPopupErro({
        aberto: true,
        mensagem: "É necessário estar autenticado para salvar as apostas."
      });
      return;
    }

    const total = getTotalPosicoes(modo, categoriaId);
    const apostasPreenchidas = apostas.filter(a => a !== null);

    if (apostasPreenchidas.length < total) {
      setPopupErro({
        aberto: true,
        mensagem: `Complete todas as ${total} vagas antes de salvar.`
      });
      return;
    }

    setPopupLoading(true);

    const docRef = doc(db, `usuarios/${user.uid}/apostasAtivas/${modo}/categorias/${categoriaId}`);
    const apostaAntigaSnap = await getDoc(docRef);

    const dadosParaSalvar = {};
    apostasPreenchidas.forEach((a, index) => {
      const pos = (index + 1).toString();
      dadosParaSalvar[pos] = {
        titulo: a.titulo,
        imagem: a.imagem || "",
        ordem: index + 1,
        ...(a.filme && { filme: a.filme }),
        ...(a.pais && { pais: a.pais }),
        idInterno: a.idInterno
      };
    });

    const agora = new Date();
    const dadosAntigos = apostaAntigaSnap.data();
    const jaTinhaApostaAntes =
      apostaAntigaSnap.exists() &&
      dadosAntigos &&
      Object.keys(dadosAntigos).length > 0;

    if (!jaTinhaApostaAntes) {
      dadosParaSalvar.dataCriacao = agora;
    }
    dadosParaSalvar.dataAtualizacao = agora;

    try {
      await setDoc(docRef, dadosParaSalvar);

      if (jaTinhaApostaAntes) {
        const chaveCategorias = `categoriasAtualizadas-${user.uid}-${modo}`;
        const chaveUltimaHora = `ultimaAtualizacao-${user.uid}-${modo}`;

        let dados = { categorias: {} };

        const armazenado = localStorage.getItem(chaveCategorias);
        if (armazenado) {
          try {
            const parse = JSON.parse(armazenado);
            dados.categorias =
              typeof parse.categorias === "object" && !Array.isArray(parse.categorias)
                ? parse.categorias
                : {};
          } catch (e) {
            console.error("Erro ao ler categorias atualizadas:", e);
            dados.categorias = {};
          }
        }

        const novaValidade = new Date(Date.now() + 7 * 24 * 60 * 60 * 1000).toISOString();
        dados.categorias[categoriaId] = novaValidade;

        localStorage.setItem(chaveCategorias, JSON.stringify(dados));
        localStorage.setItem(chaveUltimaHora, new Date().toISOString());

        const chaveStatus = `statusCategoria-${user.uid}-${modo}-${categoriaId.toLowerCase()}`;
        sessionStorage.setItem(chaveStatus, "azul");

        setUltimaAtualizacaoStorage(Date.now());
      }
      try {
        await atualizarPopularidade(
          user.uid,
          modo,
          categoriaId,
          apostasPreenchidas,
          apostaAntigaSnap
        );
        console.log("✅ atualizarPopularidade executada com sucesso");
      } catch (erroPop) {
        console.error("Erro ao atualizar popularidade:", erroPop);
      }

      await snapDropdown(user.uid, modo, categoriaId, apostasPreenchidas);

      setPopupLoading(false);
      setPopupErro({
        aberto: true,
        mensagem: "Apostas salvas com sucesso!"
      });
    } catch (erro) {
      console.error("Erro ao salvar apostas:", erro);
      setPopupLoading(false);
      setPopupErro({
        aberto: true,
        mensagem: "Erro ao salvar apostas. Tente novamente."
      });
    }
  };

  const navegarParaProximaCategoria = () => {
    const categoriasDoModo = categoriasPorModo[modo] || [];

    const indiceAtual = categoriasDoModo.indexOf(categoriaId);
    const proximaCategoria =
      categoriasDoModo[(indiceAtual + 1) % categoriasDoModo.length];

    navigate(`/perfil/${modo}/${proximaCategoria}`);
  };

  const salvarEProximo = async () => {
    const total = getTotalPosicoes(modo, categoriaId);
    const apostasPreenchidas = apostas.filter(a => a !== null);

    if (apostasPreenchidas.length < total) {
      setPopupErro({
        aberto: true,
        mensagem: `Complete todas as ${total} vagas antes de salvar.`
      });
      return;
    }
    try {
      await salvarApostas();
      setProximaCategoriaAposConfirmar(true);
      setPopupLoading(false);
      setPopupErro({
        aberto: true,
        mensagem: "Apostas salvas com sucesso!"
      });
    } catch (erro) {
      setPopupLoading(false);
      setPopupErro({
        aberto: true,
        mensagem: "Erro ao salvar apostas."
      });
    }
  };

  const candidatosOrdenados = [...candidatosFiltrados].sort((a, b) => {
    const chaveA = gerarChaveCandidato(a);
    const chaveB = gerarChaveCandidato(b);

    const popA = popularidadePonderada[chaveA] ?? 0;
    const popB = popularidadePonderada[chaveB] ?? 0;

    if (popA > popB) return -1;
    if (popA < popB) return 1;

    return a.titulo.localeCompare(b.titulo);
  });

  return (
    <>
      {popupLoading && (
        <div className="popup-loading">
          <div className="spinner"></div>
          <p>Espere suas apostas serem guardadas,<br></br>não mude de página até confirmar.</p>
        </div>
      )}

      <div className={`categoria-aposta-container ${showMiniBar && isMobile ? 'has-mini-bar' : ''}`}>
        <div className={`sticky-bar ${showSticky ? 'is-visible' : ''}`}>

          <MiniSlotsBar
            visible={isMobile && showMiniBar}
            apostas={apostas}
            quantidadeMaxima={quantidadeMaxima}
            onRemover={removerCandidato}
          />

          <div className="sticky-main">
            <div className="sticky-mode">{`${textoTipoAposta} ${nomePremiacao}`}</div>
            <div className="sticky-cat">{obterNomeCategoria(categoriaId)}</div>
          </div>
        </div>

        <AlertaUrgente />
        <div className="header">
          {/* IMAGEM DE FUNDO */}
          <div className="foto-cabecalho">
            <img
              className="imagem-capa"
              src={usuarioFirestore?.fotoCabecalho || imagemCabecalhoDefault}
              alt="Foto de cabeçalho"
            />
          </div>
          <div className="header-buttons">
            <button className="btn black" onClick={() => navigate(`/perfil/${modo}`)}>
              VOLTAR PARA AS CATEGORIAS
            </button>
          </div>
          <div className={`foto-usuario ${usuarioFirestore?.especialista ? "especialista" : ""}`}>
            <img
              className="foto-perfil"
              src={usuarioFirestore?.fotoPerfil || imagemPerfilDefault}
              alt="Foto de perfil"
            />
          </div>
        </div>

        <div className="usuario-info">
          <h1>
            {usuarioFirestore?.nome && usuarioFirestore?.sobrenome
              ? `${usuarioFirestore.nome} ${usuarioFirestore.sobrenome}`
              : "Usuário"}
          </h1>
          {usuarioFirestore?.especialista && (
            <div className="tag-especialista">ESPECIALISTA DO OSCAR</div>
          )}
          <hr className="dotted" />
          <p className="sub-apostas">{textoTipoAposta}</p>
          <h2>{nomePremiacao}</h2>
        </div>

        <div className="filtro-categorias">
          <div className="titulo-categorias" ref={candidatosHeaderRef}>CATEGORIAS</div>
          <div className="dropdown-categorias" onClick={toggleDropdown}>
            <img
              src={iconeStatus}
              className="icone-status"
              alt="Ícone status"
            />
            <span className="categoria-selecionada">{obterNomeCategoria(categoriaId)}</span>
            <span className="seta-dropdown">{dropdownAberto ? "▲" : "▼"}</span>
          </div>
          {dropdownAberto && (
            <div className="lista-categorias">
              {categorias.map((cat, index) => {
                const chave = `statusCategoria-${uid}-${modo}-${cat.slug.toLowerCase()}`;
                const statusSalvo =
                  sessionStorage.getItem(chave) ||
                  localStorage.getItem(chave) ||
                  "cinza";
                const catComStatus = { ...cat, status: statusSalvo };

                return (
                  <div key={index} className="item-categoria" onClick={() => selecionarCategoria(catComStatus)}>
                    <img src={getIconeStatus({ status: catComStatus.status })} className="icone-status" alt="Ícone status" />
                    <span>{catComStatus.nome}</span>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        <div className="categoria-titulo2" ref={tituloRef}>
          {obterNomeCategoria(categoriaId).toUpperCase()}
        </div>

        <div className="area-principal">
          <div className="coluna-candidatos">
            <div className="titulo-coluna vermelha">
              CANDIDATOS À INDICAÇÃO
            </div>
            <div className="barra-pesquisa">
              <img src={iconePesquisa} alt="Pesquisar" className="icone-pesquisa" />
              <input
                type="text"
                placeholder="Pesquisar..."
                value={busca}
                onChange={(e) => setBusca(e.target.value)}
              />
            </div>
            <div className="popularidade-titulo">
              <span>POPULARIDADE</span>
            </div>

            {carregandoCandidatos ? (
              <>
                {console.log("🎯 A mostrar spinner de candidatos")}
                <div className="spinner-candidatos">
                  <img src="https://i.imgur.com/llF5iyg.gif" alt="A carregar..." />
                </div>
              </>
            ) : (
              <>
                {console.log("✅ A mostrar candidatos carregados")}
                {candidatosOrdenados.map((cand, i) => {
                  const jaAdicionado = selecionadosPorId.has(cand.idInterno);

                  const salva = apostaPorId.get(cand.idInterno);

                  const mudouTitulo = !!salva && normalizar(cand.titulo) !== normalizar(salva.titulo);

                  const subAtual = normalizar(pegarSubtitulo(cand));
                  const subSalvo = normalizar(pegarSubtitulo(salva || {}));
                  const mudouSubtitulo = !!salva && subAtual !== subSalvo;
                  
                  const chave = gerarChaveCandidato(cand);

                  const valor = popularidadePonderada[chave];

                  return (
                    <div
                      className="linha-candidato"
                      key={i}
                      style={jaAdicionado ? { opacity: 0.4, pointerEvents: "none" } : {}}
                    >
                      {/* selo para candidatos na ESQUERDA */}
                      {!carregandoCandidatos && jaAdicionado && (mudouTitulo || mudouSubtitulo) && (
                        <div className={`selo-mudou selo-esquerda ${mudouTitulo ? 'tipo-titulo' : 'tipo-sub'}`}>
                          {mudouTitulo ? 'Título nacional foi adicionado' : 'Título nacional foi adicionado'}
                        </div>
                      )}
                      <img
                        src={adicionarIcon}
                        className="icone-candidato"
                        alt="Adicionar"
                        onClick={() => !jaAdicionado && adicionarCandidato(cand)}
                        style={{
                          visibility: jaAdicionado ? "hidden" : "visible",
                          cursor: jaAdicionado ? "default" : "pointer"
                        }}
                      />
                      <div className="wrapper-circular">
                        <img src={cand.imagem} className="poster-candidato" alt="Poster" />
                      </div>
                      <div className="nome-candidato">
                        <div>{cand.titulo}</div>
                        {cand.filme && <div className="subinfo">{cand.filme}</div>}
                        {cand.pais && <div className="subinfo">{cand.pais}</div>}
                      </div>
                      <div className="popularidade">
                        <img src={iconePopularidade} alt="Popularidade" />
                        <span className="numero-popularidade">
                          <NumeroAnimado chave={chave} valorFinal={valor} />
                        </span>
                      </div>
                    </div>
                  );
                })}
              </>
            )}
          </div>

          <div className="coluna-apostas" ref={apostasColRef}>
            <div className="titulo-coluna verde">MINHAS APOSTAS</div>
            {temAlgoParaAtualizar && (
              <div className="atualizar-todos-box">
                <button
  className="btn-atualizar-todos"
  onClick={atualizarTodos}
  disabled={carregandoCandidatos}
  style={carregandoCandidatos ? { opacity: 0.5, pointerEvents: "none" } : {}}
>
  ATUALIZAR TODOS*
</button>
                <p className="aviso-atualizacao">
                  *Se essa opção acima apareceu, isso significa que algum dos candidatos que você escolheu recebeu atualização
                  em imagem, título e/ou nome. Ao clicar no botão acima, ele atualiza automaticamente - é opcional, apenas deixa a sua aposta mais recente.
                  <strong> ATENÇÃO:</strong> Depois é necessário clicar no botão de salvar para registrar as mudanças.
                </p>
              </div>
            )}
            {apostas.map((aposta, i) => {
              const areaClass =
                i + 1 === 1 ? "area-posicao-1" :
                i + 1 === 2 ? "area-posicao-2" :
                i + 1 <= 4 ? "area-posicao-3" : "area-posicao-restante";

              const atual = aposta?.idInterno ? candidatos.find(c => c.idInterno === aposta.idInterno) : null;

              const mudouTituloDir =
                !!(aposta && atual) && normalizar(aposta.titulo) !== normalizar(atual.titulo);

              const mudouSubDir =
                !!(aposta && atual) &&
                normalizar(pegarSubtitulo(aposta)) !== normalizar(pegarSubtitulo(atual || {})); 

              return (
                <div className={`linha-aposta ${areaClass}`} key={i}>
                  {/* selo para MINHAS APOSTAS (direita) */}
                  {!carregandoCandidatos && aposta && atual && (mudouTituloDir || mudouSubDir) && (
                    <div className={`selo-mudou selo-direita ${mudouTituloDir ? 'tipo-titulo' : 'tipo-sub'}`}>
                      {mudouTituloDir ? 'Já existe o título nacional na lista' : 'Já existe o título nacional na lista'}
                    </div>
                  )}
                  <div className={`circulo-posicao cor-${i + 1}`}>{i + 1}º</div>
                  <img src={aposta?.imagem || posterDefault} className="poster-aposta" alt="Poster aposta" />
                  <div className="nome-aposta">
                    {aposta ? (
                      <>
                        <div>{aposta.titulo}</div>
                        {aposta.filme && <div className="subinfo">{aposta.filme}</div>}
                        {aposta.pais && <div className="subinfo">{aposta.pais}</div>}
                      </>
                    ) : (
                      <div className="vaga-vazia">{obterNomeCategoria(categoriaId).toUpperCase()}</div>
                    )}
                  </div>
                  {aposta && (
                    <div className="botoes-aposta">
                      <img
                        src={removerIcon}
                        alt="Remover"
                        className="icone-remover"
                        onClick={() => removerCandidato(i)}
                      />
                      <div className="setas-aposta">
                        {i > 0 && (
                          <img
                            src={setaCima}
                            alt="Subir"
                            className="icone-seta"
                            onClick={() => moverCandidato(i, -1)}
                          />
                        )}
                        {apostas[i + 1] && (
                          <img
                            src={setaBaixo}
                            alt="Descer"
                            className="icone-seta"
                            onClick={() => moverCandidato(i, 1)}
                          />
                        )}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}

            <div className="botoes-finais">
              <div className="linha-dupla">
                <button className="btn-vermelho" onClick={limparApostas}>LIMPAR</button>
                <button className="btn-azul" onClick={salvarApostas}>SALVAR</button>
              </div>
              <div className="linha-unica">
                <button className="btn-azul btn-cheio" onClick={salvarEProximo}>
                  SALVAR E PRÓXIMO
                </button>
              </div>
              <p className="nota-explicativa">
                *Se você fez qualquer mudança nas suas apostas nunca se esqueça de clicar em salvar, essa é a única forma de registrar as suas escolhas.
              </p>
            </div>
          </div>
        </div>
        <PopupErro
          aberto={popupErro.aberto}
          mensagem={popupErro.mensagem}
          aoFechar={() => {
            setPopupErro({ aberto: false, mensagem: "" });

            if (proximaCategoriaAposConfirmar) {
              setProximaCategoriaAposConfirmar(false);
              navegarParaProximaCategoria();
            }
          }}
        />
        {/* ⚠️ Aviso por cima se indisponível */}
        {disponivel === false && (
          <>
            <div className="overlay-bloqueio" />
            <div className="pagina-fechada caixa-flutuante">
              <h2>Categoria Fechada</h2>
              <p className="mensagem-fechado2">{mensagemFechado}</p>

              <div className="botoes-indisponivel">
                <button onClick={() => navigate(-1)} className="btnn cinza">
                  Voltar para a página anterior
                </button>

                {proximaDisponivel && (
                  <button
                    onClick={() => navigate(`/perfil/${modo}/${proximaDisponivel}`)}
                    className="btnn azul"
                  >
                    Próxima categoria disponível
                  </button>
                )}

                <button onClick={() => navigate(`/perfil/${modo}`)} className="btnn preta">
                  Ver todas as categorias
                </button>
              </div>
            </div>
          </>
        )}
      </div> 
    </> 
  );
}
function PopupErro({ aberto, mensagem, aoFechar }) {
  if (!aberto) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-box">
        <p>{mensagem}</p>
        <button onClick={aoFechar}>Confirmar</button>
      </div>
    </div>
  );
}

// Colar no MESMO arquivo, fora do CategoriaApostaPage (antes do export default)
function MiniSlotsBar({ visible, apostas, quantidadeMaxima, onRemover }) {
  // 👉 Hooks no topo, SEM condicionais/returns antes
  const trackRef = useRef(null);
  const prevRef = useRef(apostas);

  // Começa sempre do 1º slot quando a barrinha aparece/troca de categoria
  useEffect(() => {
    if (!visible) return;
    if (trackRef.current) trackRef.current.scrollLeft = 0;
  }, [visible, quantidadeMaxima]);

  // Se um slot acabou de ser preenchido/trocado, garante que ele entre na viewport
  useEffect(() => {
    if (!visible) return;

    const prev = prevRef.current || [];
    const next = apostas || [];
    let addedIndex = -1;

    for (let i = 0; i < Math.max(prev.length, next.length); i++) {
      const wasEmpty = !prev[i];
      const nowFilled = !!next[i];
      const mudouId =
        !!(prev[i]?.idInterno && next[i]?.idInterno && prev[i].idInterno !== next[i].idInterno);
      if ((wasEmpty && nowFilled) || mudouId) { addedIndex = i; break; }
    }

    prevRef.current = next;

    if (addedIndex >= 0 && trackRef.current) {
      const el = trackRef.current.children[addedIndex];
      if (el) {
        const left = el.offsetLeft;
        const right = left + el.offsetWidth;
        const viewLeft = trackRef.current.scrollLeft;
        const viewRight = viewLeft + trackRef.current.clientWidth;

        if (left < viewLeft) {
          trackRef.current.scrollTo({ left, behavior: "smooth" });
        } else if (right > viewRight) {
          trackRef.current.scrollTo({
            left: right - trackRef.current.clientWidth,
            behavior: "smooth"
          });
        }
      }
    }
  }, [apostas, visible]);

  const bar = (
    <div className="mini-slots-bar" role="region" aria-label="Pré-visualização das apostas (mobile)">
      <div className="mini-slots-track" ref={trackRef}>
        {Array.from({ length: quantidadeMaxima }).map((_, idx) => {
          const item = apostas[idx];
          const filled = !!item;
          const src = item?.imagem || "https://i.imgur.com/6MbQoCt.png";
          return (
            <button
              type="button"
              key={idx}
              className={`mini-slot ${filled ? "filled" : "empty"}`}
              onClick={() => item && onRemover(idx)}
              aria-label={filled ? `Remover ${item?.titulo} da posição ${idx + 1}` : `Vaga ${idx + 1} vazia`}
              title={filled ? "Remover desta posição" : ""}
            >
              <div className="mini-thumb">
                <img src={src} alt={filled ? item?.titulo : `Vaga ${idx + 1}`} />
                <span className={`slot-number cor-${idx + 1}`}>{idx + 1}º</span>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );

  // 👉 Decisão de render só aqui, depois dos hooks
  return visible ? createPortal(bar, document.body) : null;
}

export default CategoriaApostaPage;
